import { render, staticRenderFns } from "./PlanModule.vue?vue&type=template&id=24564606&scoped=true&"
import script from "./PlanModule.vue?vue&type=script&lang=js&"
export * from "./PlanModule.vue?vue&type=script&lang=js&"
import style0 from "./PlanModule.vue?vue&type=style&index=0&id=24564606&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24564606",
  null
  
)

export default component.exports